<template>
    <modal
            :linkClass="'action-icon'"
            :modalId="name"
            :title="title"
            :modalSize="'large'"
            :footer="true"
    >
        <template slot="modalBody">
            <div class="row">
                <div class="col-12">
                    <chat-messages :messages="messages" />
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import 'vue-multi-select/dist/lib/vue-multi-select.css';
    import store from '../../store.js';
    import ChatMessages from '../chat/ChatMessages.vue'

    export default {
        data() {
            return {
                messages: []
            };
        },
        async   created() {
            let employment = this.getEmployment

            if(employment !== null && employment.organization !== undefined) {
                this.organization = employment.organization.id
                store.dispatch('flexworkers/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, employment_id: this.id}).then((res) => {
                    if (res.status === 200) {
                        this.flexworkers = res.data.data
                    }
                }).catch((err) => {
                    console.log(err)
                    alert('Unexpected error downloading employments')
                });   
            }
            
        },
        props: ['index', 'title', 'value', 'name', 'chat'],
        methods: {
            
        },
        components: {
            ChatMessages,
        },
        computed: {
            ...mapGetters('employments', [
                'getEmployment'
            ]),
        },
        watch: {
            chat (newV, oldV) {
                if(newV !== null) {
                    store.dispatch('chats/getMessages', { ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, chatId: this.chat.id }).then((res) => {
                        if (res.status === 200) {
                            this.messages = res.data.data;
                        } else {
                            this.messages = [];
                        }
                    }).catch((err) => {

                    });
                }
            }
        }
    }
</script>

<style lang="scss">
@import "../../assets/scss/modal.scss";
</style>